import React from "react";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";
import PropTypes from "prop-types";

const NumericInput = React.forwardRef((props, ref) => {
  return (
    <FormGroup>
      <FormLabel>{props.label}</FormLabel>
      <FormControl
        ref={ref}
        defaultValue={props.value || 0.0}
        onChange={props.onChange}
      ></FormControl>
    </FormGroup>
  );
});

NumericInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

export default NumericInput;
